var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { managementService } from '~/config/server';
import { NetService } from '~/utils/net.service';
import { Inject } from "~/core/decorator";
import { Service } from "~/core/service";
var DepartmentService = /** @class */ (function (_super) {
    __extends(DepartmentService, _super);
    function DepartmentService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * 获取本级及以下机构
     *
     */
    DepartmentService.prototype.querySubDepartment = function () {
        return this.netService.send({
            server: managementService.departmentController.querySubDepartment
        });
    };
    /**
     * 移动组织结构
     */
    DepartmentService.prototype.moveDepartment = function (data) {
        return this.netService.send({
            server: managementService.departmentController.moveDepartment,
            data: data
        });
    };
    /**
     * 移动组织结构
     */
    DepartmentService.prototype.deleteDepartment = function (id) {
        return this.netService.send({
            server: managementService.departmentController.deleteDepartment,
            append: id
        });
    };
    /**
     * 修改部门
     */
    DepartmentService.prototype.updateDepartment = function (data) {
        return this.netService.send({
            server: managementService.departmentController.updateDepartment,
            data: data,
            loading: true
        });
    };
    /**
     * 增加部门
     */
    DepartmentService.prototype.createDepartment = function (data) {
        return this.netService.send({
            server: managementService.departmentController.createDepartment,
            data: data,
            loading: true
        });
    };
    /**
     * 绩效删除
     */
    DepartmentService.prototype.deletePerformanceDetailById = function (performanceDetailId) {
        return this.netService.send({
            server: managementService.departmentController.deletePerformanceDetailById,
            data: {
                performanceDetailId: performanceDetailId
            }
        });
    };
    __decorate([
        Inject(NetService)
    ], DepartmentService.prototype, "netService", void 0);
    return DepartmentService;
}(Service));
export { DepartmentService };
